<template lang="pug">
a.btn(
  :href="href"
  :class="buttonClass"
  :aria-label="label"
  :disabled="isDisabled"
)
  span {{ label }}
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'VLink',
    components: { Icon },
    props: {
      label: String,
      href: {
        type: String,
        default: '#',
      },
      primary: {
        type: Boolean,
        default: false,
      },
      primary_alt: {
        type: Boolean,
        default: false,
      },
      secondary: {
        type: Boolean,
        default: false,
      },
      secondary_alt: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      buttonClass() {
        return {
          'btn--primary': this.primary === true,
          'btn--primary-alternate': this.primary_alt === true,
          'btn--secondary': this.secondary === true,
          'btn--secondary-alternate': this.secondary_alt === true
        }
      },
      isDisabled() {
        return this.disabled;
      },
    },
  };
</script>

